import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Account = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: user?.name || user?.fullName || user?.username || '',
    email: user?.email || '',
    phone: user?.phoneNumber || user?.phone || '',
    address: user?.address || '',
  });
  const [success, setSuccess] = useState(false);

  // Update form when user data changes
  React.useEffect(() => {
    if (user) {
      setForm({
        name: user?.name || user?.fullName || user?.username || '',
        email: user?.email || '',
        phone: user?.phoneNumber || user?.phone || '',
        address: user?.address || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Save changes to backend
    setSuccess(true);
    setTimeout(() => setSuccess(false), 2000);
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 500 }}>
      <h2 className="mb-4">Account Information</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input type="text" className="form-control" name="name" value={form.name} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input type="email" className="form-control" name="email" value={form.email} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Phone</label>
          <input type="text" className="form-control" name="phone" value={form.phone} onChange={handleChange} />
        </div>
        <div className="mb-3">
          <label className="form-label">Address</label>
          <input type="text" className="form-control" name="address" value={form.address} onChange={handleChange} />
        </div>
        <button type="submit" className="btn btn-primary w-100">Save Changes</button>
        {success && <div className="alert alert-success mt-3">Changes saved!</div>}
      </form>
      <button
        className="btn btn-danger w-100 mt-4"
        onClick={() => { logout(); navigate('/'); }}
      >
        Logout
      </button>
    </div>
  );
};

export default Account; 